import Vue from 'vue'
import Router from 'vue-router'
import Cover from './views/Cover.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'cover',
      component: Cover
    },
    {
      path: '/gestion',
      name: 'gestion',
      component: () => import(/* webpackChunkName: "gestion" */ './views/Gestion.vue')
    },
    {
      path: '/asociacionismo',
      name: 'asociacionismo',
      component: () => import(/* webpackChunkName: "asociacionismo" */ './views/Asociacionismo.vue')
    },
    {
      path: '/gestion-administrativa',
      name: 'gestion-administrativa',
      component: () => import(/* webpackChunkName: "admininstrativa" */ './views/GestionAdministrativa.vue')
    },
    {
      path: '/gestion-economica',
      name: 'gestion-economica',
      component: () => import(/* webpackChunkName: "economica" */ './views/GestionEconomica.vue')
    },
    {
      path: '/actividades',
      name: 'actividades',
      component: () => import(/* webpackChunkName: "actividades" */ './views/Actividades.vue')
    }
  ]
})
